var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign-out-alt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.492,
    height: 32,
    viewBox: "0 0 34.492 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#112436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235684"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3470",
    "data-name": "Pfad 3470",
    className: "cls-1",
    d: "M16.671,20a1.4,1.4,0,0,0-1.453,1.333v4a4.19,4.19,0,0,1-4.358,4h-3.6a4.19,4.19,0,0,1-4.358-4V6.667a4.19,4.19,0,0,1,4.358-4h3.6a4.19,4.19,0,0,1,4.358,4v4a1.458,1.458,0,0,0,2.905,0v-4C18.118,2.987,14.869,0,10.86,0h-3.6C3.254,0,0,2.987,0,6.667V25.333C0,29.013,3.254,32,7.263,32h3.6c4.009,0,7.258-2.987,7.263-6.667v-4A1.4,1.4,0,0,0,16.671,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3471",
    "data-name": "Pfad 3471",
    className: "cls-1",
    d: "M30.954,11.09,24.293,5.366a1.625,1.625,0,0,0-2.054,0,1.128,1.128,0,0,0,0,1.765l6.191,5.321-21.977.037A1.362,1.362,0,0,0,5,13.737a1.362,1.362,0,0,0,1.453,1.248h0l22.063-.039-6.28,5.4a1.128,1.128,0,0,0,0,1.765,1.626,1.626,0,0,0,2.054,0l6.662-5.724a3.384,3.384,0,0,0,0-5.294Z",
    transform: "translate(2.263 2.263)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c4e7476ed9bbaa18541829a8c7d564bb.svg";
export { ForwardRef as ReactComponent };